import { defineMessages } from "react-intl";

export const messages = defineMessages({
  confirmTitle: {
    id: "settings.formLayouts.modal.action.confirmation.title",
    defaultMessage:
      "Changes will be immediately visible to all users who are assigned this layout.",
    description: "Title of Save confirmation",
  },
  edit: {
    id: "settings.formLayouts.modal.title.edit",
    defaultMessage: "Edit Layout",
    description: "Title of Edit Layout modal",
  },
  new: {
    id: "settings.formLayouts.modal.title.new",
    defaultMessage: "New Layout",
    description: "Title of New Layout modal",
  },
  placeholder: {
    id: "settings.formLayouts.modal.properties.title.placeholder",
    defaultMessage: "Give this layout a descriptive name...",
    description: "Placeholder for Title property field",
  },
  readOnlyFields: {
    id: "settings.formLayouts.modal.properties.readOnlyFields",
    defaultMessage: "Read-only fields can still be filled on creation of a record.",
    description: "Read-only fields alert",
  },
  save: {
    id: "settings.formLayouts.modal.action.saveLayout",
    defaultMessage: "Save Layout",
    description: "Label for Save Layout action button",
  },
  saved: {
    id: "settings.formLayouts.modal.action.saved",
    defaultMessage: "{icon} Saved",
    description: "Label for Saved action button",
  },
  selectFields: {
    id: "settings.formLayouts.modal.properties.subtitle.selectFields",
    defaultMessage: "Select Fields",
    description: "Select Fields subtitle",
  },
  understoodBtn: {
    id: "settings.formLayouts.modal.action.confirmation.understood",
    defaultMessage: "Understood",
    description: "Forms Layout Editor Modal - Understood button title",
  },
  waitBtn: {
    id: "settings.formLayouts.modal.action.confirmation.wait",
    defaultMessage: "Wait",
    description: "Forms Layout Editor Modal  - Wait button title",
  },
});
